import React, { useState, useEffect, useReducer, useMemo, useCallback } from "react";
import APIService from "../../Services/API/APIService";
import {
  Table,
  Dimmer,
  Loader,
  Dropdown,
  Menu,
  Form,
  Modal,
  Pagination

} from "semantic-ui-react";
import dayjs from "dayjs";
import numeral from "numeral";
import ProductTypes from "../../Data/ProductTypes";
import ViewActivity from "./ViewActivity";
import { sortReducer } from "../../utils/SortReducer";

const PastRecords = (props) => {
  const [loading, setLoading] = useState(false);
  const [searchPhrase, setSearchPhrase] = useState(null);
  const [selectActivity, setSelectedActivity] = useState([])
  const [activityModalState, toggleActivityModal] = useState(false);
  const [orders, setOrders] = useState([])
  const [state, dispatch] = useReducer(sortReducer, {
    column: null,
    data: null,
    direction: null,
  });

  const { data } = state;
  const [offset, setOffset] = useState(0);
  const [limit] = useState(50);
  const [rowCount, setRowCount] = useState(0);
  let query = useMemo(() => {
    return {
      offset: offset,
      limit: limit
    }
  }, [offset, limit])


  const fetchData =useCallback (async (isSubscribed) => {
    try {
      setLoading(true);
      let result = await APIService.getData("/guest-house/getPastRecords", {
        ...query
      })
      let response = await APIService.getData('/guest-house/getCustomerActivity')

      dispatch({
        type: "",
        column: "",
        payload: result.response,
      });

      if(isSubscribed){
        setRowCount(result.count)
      }
      setOrders(response)

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  },[query])


  useEffect(() => {
  let isSubscribed = true
    fetchData(isSubscribed);

       return () =>  (isSubscribed = false)
  }, [fetchData,offset]);

  const _searchChanged = (e) => {
    setSearchPhrase(e.target.value);
  };

  const _search = async () => {
    setLoading(true);
    try {
      let result = [];
      if (searchPhrase) {
        result = await APIService.getData(`/guest-house/searchPastRecords`, {
          name: searchPhrase
        });
      } else {
        result = await APIService.getData("/guest-house/searchPastRecords");
      }
      setLoading(false);

      dispatch({
        type: "",
        column: "",
        payload: result.response,
      });

      setRowCount(result.count)

    } catch (error) {
      // console.log("error", error);
      setLoading(false);
    }
  };

  const viewActivity = async (booking) => {
    try {
      setSelectedActivity(booking);
      toggleActivityModal(true);
    } catch (error) {
      console.log("error", error);
    }
  };

  let counter = 0

  let bookingItems = data?.map((item) => (

    <Table.Row key={item.id}>

      <Table.Cell>   {counter = counter + 1} </Table.Cell>

      <Table.Cell>   {item.bookingId} </Table.Cell>
      <Table.Cell>{item.GuestHousePackage?.name}</Table.Cell>
      <Table.Cell> {item.GuestHouseUser?.email !== ProductTypes.GUESTHOUSE_EMAIL ? item.GuestHouseUser?.firstname + "  " + item.GuestHouseUser?.lastname :
        item.GuestHouseSecretUser?.firstname + " " + item.GuestHouseSecretUser?.lastname}</Table.Cell>
      <Table.Cell> {item.GuestHouseUser?.email !== ProductTypes.GUESTHOUSE_EMAIL ? item.GuestHouseUser?.phoneNumber : item.GuestHouseSecretUser?.phoneNumber}</Table.Cell>
      <Table.Cell>{item.checkedInDate ? dayjs(item.checkedOutDate).format("DD-MMM-YYYY") : ''}</Table.Cell>
      <Table.Cell>{item.nights}</Table.Cell>
      <Table.Cell>
        ₦
        {
          numeral(orders.filter((e) => e.GuestHouseBookingId === item?.id).find((e) => e.name === 'Room')?.total).format("0,0")
        }

      </Table.Cell>
      <Table.Cell>
        ₦
        {
          numeral(orders.filter((e) => e.GuestHouseBookingId === item?.id).find((e) => e.name === 'Room')?.discount).format("0,0")
        }

      </Table.Cell>
      <Table.Cell>
        ₦
        {
          numeral(orders.filter((e) => e.GuestHouseBookingId === item?.id).find((e) => e.name === 'Food')?.total).format("0,0")
        }
      </Table.Cell>
      <Table.Cell>
        ₦
        {
          numeral(orders.filter((e) => e.GuestHouseBookingId === item?.id).find((e) => e.name === 'Beverage')?.total).format("0,0")

        }
      </Table.Cell>
      <Table.Cell>
        ₦
        {
          numeral(orders.filter((e) => e.GuestHouseBookingId === item?.id).find((e) => e.name === 'Snack')?.total).format("0,0")

        }
      </Table.Cell>

      <Table.Cell>
        ₦
        {
          numeral(orders.filter((e) => e.GuestHouseBookingId === item?.id).find((e) => e.name === 'Laundry')?.total).format("0,0")

        }
      </Table.Cell>


      <Table.Cell>

          ₦ {
    numeral(
      parseInt(numeral(orders.filter((e) => e.GuestHouseBookingId === item?.id).find((e) => e.name === 'Beverage')?.total).format("0")) +
      parseInt(numeral(orders.filter((e) => e.GuestHouseBookingId === item?.id).find((e) => e.name === 'Food')?.total).format("0")) +
      parseInt(numeral(orders.filter((e) => e.GuestHouseBookingId === item?.id).find((e) => e.name === 'Snack')?.total).format("0")) +
      parseInt(numeral(orders.filter((e) => e.GuestHouseBookingId === item?.id).find((e) => e.name === 'Room')?.total).format("0")) -
      parseInt(numeral(orders.filter((e) => e.GuestHouseBookingId === item?.id).find((e) => e.name === 'Room')?.discount).format("0")) +
      parseInt(numeral(orders.filter((e) => e.GuestHouseBookingId === item?.id).find((e) => e.name === 'Laundry')?.total).format("0"))
    ).format("0,0")
  }
      </Table.Cell>

      <Table.Cell>
        <Dropdown icon="ellipsis vertical" fluid floating pointing="bottom right">
          <Dropdown.Menu>


            {(item.status === "COMPLETED") && (
              <Dropdown.Item
                icon="elementor"
                text="View Activity"
                onClick={() => viewActivity(item)}
              />
            )}

          </Dropdown.Menu>
        </Dropdown>
      </Table.Cell>
    </Table.Row>
  ))




  return (

    <div>
      {loading && (
        <Dimmer active inverted>
          <Loader />
        </Dimmer>
      )}

      <Menu secondary stackable>


        <Menu.Menu position="right">
          <Menu.Item>
            <Form>
              <Form.Input
                placeholder="firstname or lastname"
                icon="search"
                onChange={_searchChanged}
                action={{
                  onClick: _search,
                  color: 'teal'
                }}

              />
            </Form>
          </Menu.Item>
        </Menu.Menu>
      </Menu>

      {data && (
        <Table striped stackable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>S/N</Table.HeaderCell>

              <Table.HeaderCell>BookingId</Table.HeaderCell>

              <Table.HeaderCell>Package</Table.HeaderCell>
              <Table.HeaderCell>Customer</Table.HeaderCell>
              <Table.HeaderCell>Phone</Table.HeaderCell>
              <Table.HeaderCell>Checked Out</Table.HeaderCell>

              <Table.HeaderCell>No of Nights</Table.HeaderCell>
              <Table.HeaderCell>Room Amount</Table.HeaderCell>
              <Table.HeaderCell>Discount</Table.HeaderCell>
              <Table.HeaderCell>Food</Table.HeaderCell>
              <Table.HeaderCell>Beverages</Table.HeaderCell>

              <Table.HeaderCell>Laundry</Table.HeaderCell>
              <Table.HeaderCell>Snack</Table.HeaderCell>
              <Table.HeaderCell> Total </Table.HeaderCell>


              <Table.HeaderCell></Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>{bookingItems}</Table.Body>
        </Table>
      )}



      <Modal
        size="small"
        open={activityModalState}
        onClose={() => toggleActivityModal(false)}
        closeIcon
      >
        <Modal.Header>View Activity</Modal.Header>
        <Modal.Content>

          <ViewActivity selectActivity={selectActivity} />
        </Modal.Content>
      </Modal>


      <Pagination
        defaultActivePage={1}
        totalPages={Math.ceil(rowCount / limit)}
        onPageChange={(e, { activePage }) =>
          setOffset(1 + (activePage - 1) * limit)
        }
      />

    </div>


  );
};

export default PastRecords